export default class SaveDataSlot {
    /**
     * @param {number} id
     */
    constructor(id) {
        this._id = id;

        this.player = { tutorial: true, mapTutorial: true, lastLocation:null};
        this.quests = {};
        this.inventory = {};
        this.coins = 0;
        this.acorns = [];
        this.treasures = [];
        this.purchases = {};
        this.settings = {};
    }

    /**
     * @return {object}
     */
    toObject() {
        return {
            player: this.player,
            quests: this.quests,
            inventory: this.inventory,
            coins: this.coins,
            acorns: this.acorns,
            treasures: this.treasures,
            purchases: this.purchases,
            settings: this.settings
        };
    }

    /**
     * @return {number}
     */
    get id() {
        return this._id;
    }
}